module.exports = __webpack_public_path__ + "img/icon2.6b9c2dae.png";